/* Art Mariem custom cart drawer */
(function () {
  var SECTION = 'am-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var recsCache = {};
  var host = null;

  function drawer() {
    return document.querySelector('cart-drawer-component');
  }

  /* Puts our drawer inside Horizon's dialog. Safe to call repeatedly. */
  function mount() {
    var comp = drawer();
    var tpl = document.getElementById('am-cart-template');
    if (!comp || !tpl) return false;
    var dialog = comp.querySelector('dialog');
    var inner = dialog && dialog.querySelector('.cart-drawer__inner');
    if (!inner) return false;
    if (host && inner.contains(host)) return true;

    if (!host) {
      host = document.createElement('div');
      host.className = 'am-cart-host';
      host.appendChild(tpl.content.cloneNode(true));
      host.addEventListener('click', onClick);
      host.addEventListener('change', onChange);
    }
    inner.replaceChildren(host);
    dialog.classList.remove('cart-drawer--empty');
    dialog.classList.add('am-cart-dialog');
    dialog.setAttribute('aria-labelledby', 'am-cart-heading');
    return true;
  }

  function init() {
    var first = mount();
    window.__amCart = first ? 'mounted' : 'waiting';

    /* Horizon can re-render the header (and the drawer inside it); re-mount when that happens. */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      if (host && document.contains(host)) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (host && document.contains(host)) return;
        if (mount()) {
          window.__amCart = 'remounted';
          refresh();
        }
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    /* Cart changed somewhere else (product page, quick add): show a loading state, then refresh. */
    document.addEventListener('cart:update', function (e) {
      var d = e.detail || {};
      if (d.sourceId === 'am-cart') return;
      if (host) host.classList.add('is-loading');
      refresh().then(function () {
        if (host) host.classList.remove('is-loading');
      });
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
    loadRecs(0);
  }

  function refresh() {
    return fetch(ROOT + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) { render(json[SECTION]); })
      .catch(function () {});
  }

  function render(html) {
    if (!host || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.am-cart');
    if (!fresh) return;
    var oldScroll = host.querySelector('.am-cart__scroll');
    var top = oldScroll ? oldScroll.scrollTop : 0;
    var oldTrack = host.querySelector('[data-am-recs-track]');
    var left = oldTrack ? oldTrack.scrollLeft : 0;
    host.replaceChildren(fresh);
    var scroll = host.querySelector('.am-cart__scroll');
    if (scroll) scroll.scrollTop = top;
    loadRecs(left);
  }

  function cartProductIds() {
    var c = host && host.querySelector('.am-cart');
    return c && c.dataset.productIds ? c.dataset.productIds.split(',') : [];
  }

  function itemCount() {
    var c = host && host.querySelector('.am-cart');
    return c ? parseInt(c.dataset.itemCount || '0', 10) : 0;
  }

  function loadRecs(left) {
    var box = host && host.querySelector('[data-am-recs]');
    if (!box) return;
    var pid = box.dataset.productId;
    if (!pid) return;

    var fill = function (html) {
      if (!host.contains(box)) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ids = cartProductIds();
      var cards = Array.prototype.filter.call(doc.querySelectorAll('.am-rec'), function (el) {
        return ids.indexOf(el.dataset.productId) === -1;
      });
      var track = box.querySelector('[data-am-recs-track]');
      if (!cards.length || !track) {
        box.hidden = true;
        return;
      }
      track.replaceChildren.apply(track, cards);
      box.hidden = false;
      if (left) track.scrollLeft = left;
    };

    if (recsCache[pid]) return fill(recsCache[pid]);
    fetch(ROOT + 'recommendations/products?product_id=' + pid + '&limit=8&section_id=am-cart-recs')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        recsCache[pid] = html;
        fill(html);
      })
      .catch(function () {});
  }

  function notify() {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'am-cart', data: { itemCount: itemCount(), source: 'am-cart-drawer' } }
      })
    );
  }

  function showError(message) {
    var el = host.querySelector('[data-am-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function post(url, body) {
    host.classList.add('is-busy');
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok) {
          return refresh().then(function () {
            showError(res.json.description || res.json.message || 'Something went wrong. Please try again.');
          });
        }
        var html = res.json.sections && res.json.sections[SECTION];
        return (html ? Promise.resolve(render(html)) : refresh()).then(notify);
      })
      .catch(function () {
        showError('Something went wrong. Please try again.');
      })
      .finally(function () {
        host.classList.remove('is-busy');
      });
  }

  function changeLine(key, quantity) {
    return post('cart/change.js', { id: key, quantity: quantity, sections: SECTION });
  }

  function onClick(e) {
    var t = e.target.closest('button');
    if (!t || !host.contains(t)) return;

    if (t.hasAttribute('data-am-close')) {
      var d = drawer();
      if (d && typeof d.close === 'function') d.close();
      return;
    }

    var item = t.closest('[data-key]');

    if (t.hasAttribute('data-am-qty') && item) {
      var input = item.querySelector('[data-am-qty-input]');
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(t.getAttribute('data-am-qty'), 10));
      input.value = q;
      changeLine(item.dataset.key, q);
      return;
    }

    if (t.hasAttribute('data-am-remove') && item) {
      changeLine(item.dataset.key, 0);
      return;
    }

    if (t.hasAttribute('data-am-recs-prev') || t.hasAttribute('data-am-recs-next')) {
      var track = host.querySelector('[data-am-recs-track]');
      if (track) {
        var dir = t.hasAttribute('data-am-recs-next') ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      }
      return;
    }

    if (t.hasAttribute('data-am-rec-add')) {
      var card = t.closest('.am-rec');
      var variant = card && card.querySelector('[data-am-rec-variant]');
      if (!variant || !variant.value) return;
      t.disabled = true;
      post('cart/add.js', { items: [{ id: parseInt(variant.value, 10), quantity: 1 }], sections: SECTION });
    }
  }

  function onChange(e) {
    var t = e.target;
    if (t.matches('[data-am-qty-input]')) {
      var item = t.closest('[data-key]');
      if (item) changeLine(item.dataset.key, Math.max(0, parseInt(t.value, 10) || 0));
      return;
    }
    if (t.matches('select[data-am-rec-variant]')) {
      var opt = t.options[t.selectedIndex];
      var card = t.closest('.am-rec');
      var price = card.querySelector('[data-am-rec-price]');
      var compare = card.querySelector('[data-am-rec-compare]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
